import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { normalizeCrmProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { CrmIntegrationObject, ILeadsFilterOptionsDto } from "app/pages/sales-intelligence/domain/leads/types/filter-options";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { leadsSearchFiltersQueryKeys } from "./queryKeyFactory";

const normalizeCrmIntegrations = (list: readonly CrmIntegrationObject[]): CrmIntegrationObject[] =>
    list.map((item) => ({ ...item, integrationName: normalizeCrmProvider(item.integrationName) }));

const normalizeDescription = (data: ILeadsFilterOptionsDto): ILeadsFilterOptionsDto => ({
    ...data,
    integrationsLists: normalizeCrmIntegrations(data.integrationsLists),
    userIntegrationsLists: normalizeCrmIntegrations(data.userIntegrationsLists),
});

type UseLeadsDescriptionQueryOptions = {
    enabled?: boolean;
};

export default function useLeadsDescriptionQuery({ enabled = true }: UseLeadsDescriptionQueryOptions = {}) {
    return useQuery({
        enabled,
        staleTime: Number.POSITIVE_INFINITY,
        placeholderData: keepPreviousData,
        queryKey: leadsSearchFiltersQueryKeys.description(),
        queryFn: ({ signal }) => salesApiService.leadsSearchFilters.fetchDescription({ cancellation: signal }),
        select: normalizeDescription,
    });
}
